import React, { useState, useEffect } from 'react';

const Footer = () => {
    const [currentTime, setCurrentTime] = useState('');

    useEffect(() => {
        const intervalId = setInterval(() => {
            const time = new Date();
            const formattedDate = time.toLocaleString(); 
            setCurrentTime(formattedDate);
        }, 1000);

        return () => {
            clearInterval(intervalId); 
        };
    }, []);

    return (
        <div className='mainNav'>
            <footer className='w-100 p-1 d-md-flex justify-content-between text-light'>
                <span>{currentTime}</span><br />
                <a href="https://www.codehomies.in/">ARJCET® ERP Developed by Code Homies</a>
            </footer>
        </div>
    );
};

export default Footer;
